/*
 * @Descripttion:
 * @Author: etong
 * @Date: 2022-09-28 10:29:39
 * @LastEditors: WangQi
 * @LastEditTime: 2022-11-16 15:49:04
 */
// 一盘货
const map = {
  virtualWarehouseManagement: () => import('@/views/shareInventory/VirtualWarehouseManagement'), // 虚拟仓管理
  inventoryManage: () => import('@/views/shareInventory/InventoryManage'), // 库存管理
  internalTransactionOrder: () => import('@/views/shareInventory/InternalTransactionOrder'), // 内部交易订单
  internalTransactionReturnOrder: () => import('@/views/shareInventory/InternalTransactionReturnOrder'), // 内部交易退货订单
  inventoryAccount: () => import('@/views/shareInventory/InventoryAccount'), // 库存台账
  warehousingOrder: () => import('@/views/shareInventory/WarehousingOrder'), // 入库单
  outboundOrder: () => import('@/views/shareInventory/OutboundOrder'), // 出库单
  saleStockOut: () => import('@/views/shareInventory/SaleStockOut'), // 销售出库单
  transferOrder: () => import('@/views/shareInventory/TransferOrder'), // 调拨单
  transferApplyOrder: () => import('@/views/shareInventory/TransferApplyOrder'), // 调拨申请单
  createTransferApplyOrderDetail: () => import('@/views/shareInventory/TransferApplyOrderDetail'), // 新建调拨申请单
  editTransferApplyOrderDetail: () => import('@/views/shareInventory/TransferApplyOrderDetail'), // 编辑调拨申请单
  viewTransferApplyOrderDetail: () => import('@/views/shareInventory/TransferApplyOrderDetail'), // 查看调拨申请单
  erpaPreExchangeOrder: () => import('@/views/shareInventory/ErpaPreExchangeOrder'), // 换货单待处理
  erpaExchangeOrderDetail: () => import('@/views/shareInventory/components/ErpaExchangeOrderDetail'), // 换货单
  customsDeclarationList: () => import('@/views/shareInventory/CustomsDeclarationList'), // 报关单生成管理
  customsDeclarationDetail: () => import('@/views/shareInventory/CustomsDeclarationDetail') // 报关单详情

}

export default map
